import './HeroSection.css';
// import ImageShowcaseDesktop from './ImageShowcaseDesktop';
// import ImageShowcase from './ImageShowcase';
import VideoShowcase from './VideoShowcase';
 
  
function HeroSection({ scrollToContactSection}) {

return (

<section  className="heroSection">

<div className='hero-pictures-box'>
          {/* <ImageShowcase /> */}
  <VideoShowcase/>
      
</div>

<div className='hero-text-box' style={{ }}  >
<img src="./for-all-app/kerk_logo.svg" alt="Kerk Logo"  className='hero-logo'  />
<div className='hero-txt' >
<div  dir="rtl" >  
{/* <h1 className='color-blue-dark  ' dir="rtl">פורצים קדימה{'\n'} עם המותג שלכם</h1> */}
<h1 className='color-blue-dark  ' dir="rtl">מניעים מותגים  </h1>


<h4 className='color-blue-dark' dir="rtl" 
// style={{ maxWidth: "350px" }}
  > Motion & Design ברמה גבוהה מדויק, מחושב ועובד מעולה </h4>

 

<p className='color-blue-dark' dir="rtl">משרדי פרסום | מותגים | לקוחות ישירים</p>


{/* <h4 className='color-blue-dark' dir="rtl"> */}
      {/* אנחנו בונים מותגים שזזים: לוגו, מיתוג, אתרים, סרטים ועיצוב שיווקי – הכול עם חשיבה אסטרטגית, עיצוב ברמה גבוהה, והבנה עמוקה של הקהל שלכם. */}
           {/* אנחנו בונים מותגים מנצחים: לוגו, מיתוג, אתרים, הפקת סרטים, יחד עם אסטרטגיה שיווקית ועיצוב ברמה גבוהה, שישפיעו על קהל היעד שלכם לאורך זמן וירימו את העסק  שלכם למסלול של צמיחה */}
      {/* </h4> */}

<button className='btn-type-b mt-m mobile-hide' dir="rtl" onClick={ scrollToContactSection}><p>כמה זה עולה?</p><img src='./for-all-app/arrow1.svg'alt={`arrow`} style={{height:"12px"}} className=' '/> </button>

</div>
</div>


{/* <div  style={{ height: logoHeight}} />   */}



</div>
 


</section >
);
}

export default HeroSection;